// Generated automatically from open-lofi catalog.json
export interface MusicTrack {
    id: string
    title: string
    artist: string
    filename: string
    category: string
    url: string
}

export interface MusicCategory {
    id: string
    label: string
    icon: string
}

export const MUSIC_CATEGORIES: MusicCategory[] = [
    { id: 'all', label: 'All Vibes', icon: '🎵' },
    { id: 'sfx', label: 'Sound Effects (SFX)', icon: '🔊' },
    { id: 'activities', label: 'Focus & Study', icon: '💻' },
    { id: 'chillhop', label: 'Chill & Cozy', icon: '☕' },
    { id: 'jazzhop', label: 'Jazz & Bookstore', icon: '📚' },
    { id: 'ambient-lofi', label: 'Ambient Drift', icon: '🌌' },
    { id: 'soul-rnb', label: 'Soul & Slow Jams', icon: '🕯️' },
    { id: 'asian-lofi', label: 'Zen & Calm', icon: '🎋' },
    { id: 'funk-soul', label: 'Retro Bounce', icon: '⚡' },
    { id: 'seasonal-weather', label: 'Seasons & Rain', icon: '☔' },
    { id: 'late-night', label: 'Late Night Neon', icon: '🌙' },
    { id: 'hybrid', label: 'Cinematic & Vlog', icon: '🎬' },
];

export const MUSIC_TRACKS: MusicTrack[] = [
    // Local Sound Effects (SFX)
    {
        id: 'sfx-local-whoosh-14',
        title: 'Whoosh Swoosh 14',
        artist: 'Local Asset',
        filename: '14. Whoosh Swoosh.wav',
        category: 'sfx',
        url: '/sfx/14. Whoosh Swoosh.wav'
    },
    {
        id: 'sfx-local-whoosh-15',
        title: 'Whoosh Swoosh 15',
        artist: 'Local Asset',
        filename: '15. Whoosh Swoosh.wav',
        category: 'sfx',
        url: '/sfx/15. Whoosh Swoosh.wav'
    },
    {
        id: 'sfx-local-whoosh-18',
        title: 'Whoosh Swoosh 18',
        artist: 'Local Asset',
        filename: '18. Whoosh Swoosh.wav',
        category: 'sfx',
        url: '/sfx/18. Whoosh Swoosh.wav'
    },
    {
        id: 'sfx-local-click-digital',
        title: 'Digital Click 1',
        artist: 'Local Asset',
        filename: 'Click 1 (digital).wav',
        category: 'sfx',
        url: '/sfx/Click 1 (digital).wav'
    },
    {
        id: 'sfx-local-switch-click',
        title: 'Switch Click 16',
        artist: 'Local Asset',
        filename: 'Click 16-Switch Click.mp3',
        category: 'sfx',
        url: '/sfx/Click 16-Switch Click.mp3'
    },
    {
        id: 'sfx-local-click-mechanic',
        title: 'Mechanic Click 2',
        artist: 'Local Asset',
        filename: 'Click 2 (mechanic).wav',
        category: 'sfx',
        url: '/sfx/Click 2 (mechanic).wav'
    },
    {
        id: 'sfx-local-fast-woosh',
        title: 'Fast Silent Woosh 1',
        artist: 'Local Asset',
        filename: 'Fast silent woosh 1.wav',
        category: 'sfx',
        url: '/sfx/Fast silent woosh 1.wav'
    },
    {
        id: 'sfx-local-glitch',
        title: 'Glitch Effect',
        artist: 'Local Asset',
        filename: 'Glitch.mp3',
        category: 'sfx',
        url: '/sfx/Glitch.mp3'
    },
    {
        id: 'sfx-local-swoosh-08',
        title: 'Swoosh SFX 8',
        artist: 'Local Asset',
        filename: 'SFX- Swoosh08.mp3',
        category: 'sfx',
        url: '/sfx/SFX- Swoosh08.mp3'
    },
    {
        id: 'sfx-local-swoosh-12',
        title: 'Swoosh SFX 12',
        artist: 'Local Asset',
        filename: 'SFX- Swoosh12.mp3',
        category: 'sfx',
        url: '/sfx/SFX- Swoosh12.mp3'
    },
    {
        id: 'sfx-local-swoosh-16',
        title: 'Swoosh SFX 16',
        artist: 'Local Asset',
        filename: 'SFX- Swoosh16.mp3',
        category: 'sfx',
        url: '/sfx/SFX- Swoosh16.mp3'
    },
    {
        id: 'sfx-local-slow-woosh',
        title: 'Slow Woosh 5',
        artist: 'Local Asset',
        filename: 'Slow woosh 5.wav',
        category: 'sfx',
        url: '/sfx/Slow woosh 5.wav'
    },
    {
        id: 'sfx-local-zoom',
        title: 'Zoom Effect 3',
        artist: 'Local Asset',
        filename: 'zoom (3).wav',
        category: 'sfx',
        url: '/sfx/zoom (3).wav'
    },
    // Open-Source Royalty-Free Sound Effects (SFX)
    {
        id: 'sfx-whoosh',
        title: 'Fast Whoosh Swoosh',
        artist: 'Royalty-Free (CC0)',
        filename: 'whoosh.wav',
        category: 'sfx',
        url: 'sfx:whoosh'
    },
    {
        id: 'sfx-pop',
        title: 'Bubble UI Pop',
        artist: 'Royalty-Free (CC0)',
        filename: 'pop.wav',
        category: 'sfx',
        url: 'sfx:pop'
    },
    {
        id: 'sfx-click',
        title: 'Crisp Click Tap',
        artist: 'Royalty-Free (CC0)',
        filename: 'click.wav',
        category: 'sfx',
        url: 'sfx:click'
    },
    {
        id: 'sfx-ding',
        title: 'Bright Bell Chime',
        artist: 'Royalty-Free (CC0)',
        filename: 'ding.wav',
        category: 'sfx',
        url: 'sfx:ding'
    },
    {
        id: 'sfx-shutter',
        title: 'Camera Shutter Snap',
        artist: 'Royalty-Free (CC0)',
        filename: 'shutter.wav',
        category: 'sfx',
        url: 'sfx:shutter'
    },
    {
        id: 'sfx-success',
        title: 'Success Arpeggio Chime',
        artist: 'Royalty-Free (CC0)',
        filename: 'success.wav',
        category: 'sfx',
        url: 'sfx:success'
    },
    {
        id: 'sfx-boom',
        title: 'Sub Drop Bass Impact',
        artist: 'Royalty-Free (CC0)',
        filename: 'boom.wav',
        category: 'sfx',
        url: 'sfx:boom'
    },
    {
        id: 'sfx-sparkle',
        title: 'Magic Shimmer Sparkle',
        artist: 'Royalty-Free (CC0)',
        filename: 'sparkle.wav',
        category: 'sfx',
        url: 'sfx:sparkle'
    },
    {
        id: 'track-1',
        title: '2 AM Debug Loop',
        artist: 'Open Lo-Fi (CC0)',
        filename: '2-am-debug-loop.mp3',
        category: 'activities',
        url: '/music/2-am-debug-loop.mp3'
    },

    {
        id: 'track-2',
        title: 'Brushstrokes and Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'brushstrokes-and-rain.mp3',
        category: 'activities',
        url: '/music/brushstrokes-and-rain.mp3'
    },
    {
        id: 'track-3',
        title: 'Butter and Windowlight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'butter-and-windowlight.mp3',
        category: 'activities',
        url: '/music/butter-and-windowlight.mp3'
    },
    {
        id: 'track-4',
        title: 'Chapter By Lamplight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'chapter-by-lamplight.mp3',
        category: 'activities',
        url: '/music/chapter-by-lamplight.mp3'
    },
    {
        id: 'track-5',
        title: 'Coffee Ring Notebook',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'coffee-ring-notebook.mp3',
        category: 'activities',
        url: '/music/coffee-ring-notebook.mp3'
    },
    {
        id: 'track-6',
        title: 'Continue Screen Dreams',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'continue-screen-dreams.mp3',
        category: 'activities',
        url: '/music/continue-screen-dreams.mp3'
    },
    {
        id: 'track-7',
        title: 'Cursor After Midnight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'cursor-after-midnight.mp3',
        category: 'activities',
        url: '/music/cursor-after-midnight.mp3'
    },
    {
        id: 'track-8',
        title: 'Dog Eared Pages',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dog-eared-pages.mp3',
        category: 'activities',
        url: '/music/dog-eared-pages.mp3'
    },
    {
        id: 'track-9',
        title: 'Dust in the Curtains',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dust-in-the-curtains.mp3',
        category: 'activities',
        url: '/music/dust-in-the-curtains.mp3'
    },
    {
        id: 'track-10',
        title: 'Exhale the Morning',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'exhale-the-morning.mp3',
        category: 'activities',
        url: '/music/exhale-the-morning.mp3'
    },
    {
        id: 'track-11',
        title: 'Faded Corners of the Page',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'faded-corners-of-the-page.mp3',
        category: 'activities',
        url: '/music/faded-corners-of-the-page.mp3'
    },
    {
        id: 'track-12',
        title: 'First Coffee Thoughts',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'first-coffee-thoughts.mp3',
        category: 'activities',
        url: '/music/first-coffee-thoughts.mp3'
    },
    {
        id: 'track-13',
        title: 'Graphite in the Quiet',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'graphite-in-the-quiet.mp3',
        category: 'activities',
        url: '/music/graphite-in-the-quiet.mp3'
    },
    {
        id: 'track-14',
        title: 'Graphite Mornings',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'graphite-mornings.mp3',
        category: 'activities',
        url: '/music/graphite-mornings.mp3'
    },
    {
        id: 'track-15',
        title: 'Hour Between Clicks',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'hour-between-clicks.mp3',
        category: 'activities',
        url: '/music/hour-between-clicks.mp3'
    },
    {
        id: 'track-16',
        title: 'Kettle Before Work',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'kettle-before-work.mp3',
        category: 'activities',
        url: '/music/kettle-before-work.mp3'
    },
    {
        id: 'track-17',
        title: 'Margin Notes at Dusk',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'margin-notes-at-dusk.mp3',
        category: 'activities',
        url: '/music/margin-notes-at-dusk.mp3'
    },
    {
        id: 'track-18',
        title: 'Mat and Morning Light',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'mat-and-morning-light.mp3',
        category: 'activities',
        url: '/music/mat-and-morning-light.mp3'
    },
    {
        id: 'track-19',
        title: 'Morning in the Hiss',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'morning-in-the-hiss.mp3',
        category: 'activities',
        url: '/music/morning-in-the-hiss.mp3'
    },
    {
        id: 'track-20',
        title: 'Morning Pages',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'morning-pages.mp3',
        category: 'activities',
        url: '/music/morning-pages.mp3'
    },
    {
        id: 'track-21',
        title: 'Pancakes in the Sun',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'pancakes-in-the-sun.mp3',
        category: 'activities',
        url: '/music/pancakes-in-the-sun.mp3'
    },
    {
        id: 'track-22',
        title: 'Penciled Sunbeams',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'penciled-sunbeams.mp3',
        category: 'activities',
        url: '/music/penciled-sunbeams.mp3'
    },
    {
        id: 'track-23',
        title: 'Pixel Quest Save Point',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'pixel-quest-save-point.mp3',
        category: 'activities',
        url: '/music/pixel-quest-save-point.mp3'
    },
    {
        id: 'track-24',
        title: 'Quiet Lungs Quiet Light',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'quiet-lungs-quiet-light.mp3',
        category: 'activities',
        url: '/music/quiet-lungs-quiet-light.mp3'
    },
    {
        id: 'track-25',
        title: 'Stacks of Quiet Hours',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'stacks-of-quiet-hours.mp3',
        category: 'activities',
        url: '/music/stacks-of-quiet-hours.mp3'
    },
    {
        id: 'track-26',
        title: 'Sunday Light Through Lace',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sunday-light-through-lace.mp3',
        category: 'activities',
        url: '/music/sunday-light-through-lace.mp3'
    },
    {
        id: 'track-27',
        title: 'Sunrise Stretch Flow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sunrise-stretch-flow.mp3',
        category: 'activities',
        url: '/music/sunrise-stretch-flow.mp3'
    },
    {
        id: 'track-28',
        title: 'Terminal Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'terminal-rain.mp3',
        category: 'activities',
        url: '/music/terminal-rain.mp3'
    },
    {
        id: 'track-29',
        title: 'Watercolors By the Window',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'watercolors-by-the-window.mp3',
        category: 'activities',
        url: '/music/watercolors-by-the-window.mp3'
    },
    {
        id: 'track-30',
        title: 'Almost Floating',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'almost-floating.mp3',
        category: 'ambient-lofi',
        url: '/music/almost-floating.mp3'
    },
    {
        id: 'track-31',
        title: 'Aurora on Mute',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'aurora-on-mute.mp3',
        category: 'ambient-lofi',
        url: '/music/aurora-on-mute.mp3'
    },
    {
        id: 'track-32',
        title: 'Blue Below the Surface',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'blue-below-the-surface.mp3',
        category: 'ambient-lofi',
        url: '/music/blue-below-the-surface.mp3'
    },
    {
        id: 'track-33',
        title: 'Cathedral Hiss',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'cathedral-hiss.mp3',
        category: 'ambient-lofi',
        url: '/music/cathedral-hiss.mp3'
    },
    {
        id: 'track-34',
        title: 'Deep Space Loop',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'deep-space-loop.mp3',
        category: 'ambient-lofi',
        url: '/music/deep-space-loop.mp3'
    },
    {
        id: 'track-35',
        title: 'Drifting Through Fog',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'drifting-through-fog.mp3',
        category: 'ambient-lofi',
        url: '/music/drifting-through-fog.mp3'
    },
    {
        id: 'track-36',
        title: 'First Light on the Ridge',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'first-light-on-the-ridge.mp3',
        category: 'ambient-lofi',
        url: '/music/first-light-on-the-ridge.mp3'
    },
    {
        id: 'track-37',
        title: 'Ghosts on the Hillside',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'ghosts-on-the-hillside.mp3',
        category: 'ambient-lofi',
        url: '/music/ghosts-on-the-hillside.mp3'
    },
    {
        id: 'track-38',
        title: 'Glasshouse Ghosts',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'glasshouse-ghosts.mp3',
        category: 'ambient-lofi',
        url: '/music/glasshouse-ghosts.mp3'
    },
    {
        id: 'track-39',
        title: 'Green After Midnight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'green-after-midnight.mp3',
        category: 'ambient-lofi',
        url: '/music/green-after-midnight.mp3'
    },
    {
        id: 'track-40',
        title: 'Misty Mountain Sunrise',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'misty-mountain-sunrise.mp3',
        category: 'ambient-lofi',
        url: '/music/misty-mountain-sunrise.mp3'
    },
    {
        id: 'track-41',
        title: 'Moonlit Moss',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'moonlit-moss.mp3',
        category: 'ambient-lofi',
        url: '/music/moonlit-moss.mp3'
    },
    {
        id: 'track-42',
        title: 'Orbiting in Silence',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'orbiting-in-silence.mp3',
        category: 'ambient-lofi',
        url: '/music/orbiting-in-silence.mp3'
    },
    {
        id: 'track-43',
        title: 'Polar Afterglow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'polar-afterglow.mp3',
        category: 'ambient-lofi',
        url: '/music/polar-afterglow.mp3'
    },
    {
        id: 'track-44',
        title: 'Satellite Lullaby',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'satellite-lullaby.mp3',
        category: 'ambient-lofi',
        url: '/music/satellite-lullaby.mp3'
    },
    {
        id: 'track-45',
        title: 'Sea Glass Evening',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sea-glass-evening.mp3',
        category: 'ambient-lofi',
        url: '/music/sea-glass-evening.mp3'
    },
    {
        id: 'track-46',
        title: 'Soft Weightless Hours',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'soft-weightless-hours.mp3',
        category: 'ambient-lofi',
        url: '/music/soft-weightless-hours.mp3'
    },
    {
        id: 'track-47',
        title: 'Stained Glass Static',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'stained-glass-static.mp3',
        category: 'ambient-lofi',
        url: '/music/stained-glass-static.mp3'
    },
    {
        id: 'track-48',
        title: 'Tide Pools at Twilight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'tide-pools-at-twilight.mp3',
        category: 'ambient-lofi',
        url: '/music/tide-pools-at-twilight.mp3'
    },
    {
        id: 'track-49',
        title: 'Underwater Dreamscape',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'underwater-dreamscape.mp3',
        category: 'ambient-lofi',
        url: '/music/underwater-dreamscape.mp3'
    },
    {
        id: 'track-50',
        title: 'Warm Constellations',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'warm-constellations.mp3',
        category: 'ambient-lofi',
        url: '/music/warm-constellations.mp3'
    },
    {
        id: 'track-51',
        title: 'Bamboo Shadow Waltz',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'bamboo-shadow-waltz.mp3',
        category: 'asian-lofi',
        url: '/music/bamboo-shadow-waltz.mp3'
    },
    {
        id: 'track-52',
        title: 'Bells Before Sunrise',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'bells-before-sunrise.mp3',
        category: 'asian-lofi',
        url: '/music/bells-before-sunrise.mp3'
    },
    {
        id: 'track-53',
        title: 'Lanterns in Slow Motion',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'lanterns-in-slow-motion.mp3',
        category: 'asian-lofi',
        url: '/music/lanterns-in-slow-motion.mp3'
    },
    {
        id: 'track-54',
        title: 'Misty Steam Quiet Dreams',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'misty-steam-quiet-dreams.mp3',
        category: 'asian-lofi',
        url: '/music/misty-steam-quiet-dreams.mp3'
    },
    {
        id: 'track-55',
        title: 'Moon Through Bamboo',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'moon-through-bamboo.mp3',
        category: 'asian-lofi',
        url: '/music/moon-through-bamboo.mp3'
    },
    {
        id: 'track-56',
        title: 'Paper Lantern Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'paper-lantern-rain.mp3',
        category: 'asian-lofi',
        url: '/music/paper-lantern-rain.mp3'
    },
    {
        id: 'track-57',
        title: 'Teacup Morning Fog',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'teacup-morning-fog.mp3',
        category: 'asian-lofi',
        url: '/music/teacup-morning-fog.mp3'
    },
    {
        id: 'track-58',
        title: 'Temple at Dawn',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'temple-at-dawn.mp3',
        category: 'asian-lofi',
        url: '/music/temple-at-dawn.mp3'
    },
    {
        id: 'track-59',
        title: 'Dusk Between Stoops',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dusk-between-stoops.mp3',
        category: 'chillhop',
        url: '/music/dusk-between-stoops.mp3'
    },
    {
        id: 'track-60',
        title: 'Dust on the Morning Keys',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dust-on-the-morning-keys.mp3',
        category: 'chillhop',
        url: '/music/dust-on-the-morning-keys.mp3'
    },
    {
        id: 'track-61',
        title: 'Glow on the Overpass',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'glow-on-the-overpass.mp3',
        category: 'chillhop',
        url: '/music/glow-on-the-overpass.mp3'
    },
    {
        id: 'track-62',
        title: 'Porchlight Golden Hour',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'porchlight-golden-hour.mp3',
        category: 'chillhop',
        url: '/music/porchlight-golden-hour.mp3'
    },
    {
        id: 'track-63',
        title: 'Sidewalk Slow Jam',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sidewalk-slow-jam.mp3',
        category: 'chillhop',
        url: '/music/sidewalk-slow-jam.mp3'
    },
    {
        id: 'track-64',
        title: 'Soft Gold Sky',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'soft-gold-sky.mp3',
        category: 'chillhop',
        url: '/music/soft-gold-sky.mp3'
    },
    {
        id: 'track-65',
        title: 'Sunset Offbeat',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sunset-offbeat.mp3',
        category: 'chillhop',
        url: '/music/sunset-offbeat.mp3'
    },
    {
        id: 'track-66',
        title: 'Window Seat Daydream',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'window-seat-daydream.mp3',
        category: 'chillhop',
        url: '/music/window-seat-daydream.mp3'
    },
    {
        id: 'track-67',
        title: 'Basement Groove 86',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'basement-groove-86.mp3',
        category: 'funk-soul',
        url: '/music/basement-groove-86.mp3'
    },
    {
        id: 'track-68',
        title: 'Block Party Slow Jam',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'block-party-slow-jam.mp3',
        category: 'funk-soul',
        url: '/music/block-party-slow-jam.mp3'
    },
    {
        id: 'track-69',
        title: 'Burnt Sunset Groove',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'burnt-sunset-groove.mp3',
        category: 'funk-soul',
        url: '/music/burnt-sunset-groove.mp3'
    },
    {
        id: 'track-70',
        title: 'Cassette Basement Bounce',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'cassette-basement-bounce.mp3',
        category: 'funk-soul',
        url: '/music/cassette-basement-bounce.mp3'
    },
    {
        id: 'track-71',
        title: 'Dust on the Needle',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dust-on-the-needle.mp3',
        category: 'funk-soul',
        url: '/music/dust-on-the-needle.mp3'
    },
    {
        id: 'track-72',
        title: 'Dusty Jukebox Heart',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dusty-jukebox-heart.mp3',
        category: 'funk-soul',
        url: '/music/dusty-jukebox-heart.mp3'
    },
    {
        id: 'track-73',
        title: 'Grandmas Kitchen on Sunday',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'grandmas-kitchen-on-sunday.mp3',
        category: 'funk-soul',
        url: '/music/grandmas-kitchen-on-sunday.mp3'
    },
    {
        id: 'track-74',
        title: 'Mirrorball Slow Roll',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'mirrorball-slow-roll.mp3',
        category: 'funk-soul',
        url: '/music/mirrorball-slow-roll.mp3'
    },
    {
        id: 'track-75',
        title: 'Motel Soul Radio',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'motel-soul-radio.mp3',
        category: 'funk-soul',
        url: '/music/motel-soul-radio.mp3'
    },
    {
        id: 'track-76',
        title: 'Neon on the Diner Floor',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'neon-on-the-diner-floor.mp3',
        category: 'funk-soul',
        url: '/music/neon-on-the-diner-floor.mp3'
    },
    {
        id: 'track-77',
        title: 'Peach Cobbler Static',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'peach-cobbler-static.mp3',
        category: 'funk-soul',
        url: '/music/peach-cobbler-static.mp3'
    },
    {
        id: 'track-78',
        title: 'Roller Rink Reverie',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'roller-rink-reverie.mp3',
        category: 'funk-soul',
        url: '/music/roller-rink-reverie.mp3'
    },
    {
        id: 'track-79',
        title: 'Smoke in the Orange Sky',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'smoke-in-the-orange-sky.mp3',
        category: 'funk-soul',
        url: '/music/smoke-in-the-orange-sky.mp3'
    },
    {
        id: 'track-80',
        title: 'Summer Curbside Glow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'summer-curbside-glow.mp3',
        category: 'funk-soul',
        url: '/music/summer-curbside-glow.mp3'
    },
    {
        id: 'track-81',
        title: 'Cafe Da Tarde',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'cafe-da-tarde.mp3',
        category: 'hybrid',
        url: '/music/cafe-da-tarde.mp3'
    },
    {
        id: 'track-82',
        title: 'Cassette Pastel Nights',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'cassette-pastel-nights.mp3',
        category: 'hybrid',
        url: '/music/cassette-pastel-nights.mp3'
    },
    {
        id: 'track-83',
        title: 'Dusk on Red Earth',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dusk-on-red-earth.mp3',
        category: 'hybrid',
        url: '/music/dusk-on-red-earth.mp3'
    },
    {
        id: 'track-84',
        title: 'End Scene Glow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'end-scene-glow.mp3',
        category: 'hybrid',
        url: '/music/end-scene-glow.mp3'
    },
    {
        id: 'track-85',
        title: 'Midnight Steam and Mango Skin',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-steam-and-mango-skin.mp3',
        category: 'hybrid',
        url: '/music/midnight-steam-and-mango-skin.mp3'
    },
    {
        id: 'track-86',
        title: 'Quiet Credits',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'quiet-credits.mp3',
        category: 'hybrid',
        url: '/music/quiet-credits.mp3'
    },
    {
        id: 'track-87',
        title: 'Savanna Slow Glow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'savanna-slow-glow.mp3',
        category: 'hybrid',
        url: '/music/savanna-slow-glow.mp3'
    },
    {
        id: 'track-88',
        title: 'VHS Heartbeat',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'vhs-heartbeat.mp3',
        category: 'hybrid',
        url: '/music/vhs-heartbeat.mp3'
    },
    {
        id: 'track-89',
        title: 'Ashes in the Coffee Cup',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'ashes-in-the-coffee-cup.mp3',
        category: 'jazzhop',
        url: '/music/ashes-in-the-coffee-cup.mp3'
    },
    {
        id: 'track-90',
        title: 'Breezy Afternoon Terrace',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'breezy-afternoon-terrace.mp3',
        category: 'jazzhop',
        url: '/music/breezy-afternoon-terrace.mp3'
    },
    {
        id: 'track-91',
        title: 'Candlelit at 70 BPM',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'candlelit-at-70-bpm.mp3',
        category: 'jazzhop',
        url: '/music/candlelit-at-70-bpm.mp3'
    },
    {
        id: 'track-92',
        title: 'Dust and Hardcovers',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'dust-and-hardcovers.mp3',
        category: 'jazzhop',
        url: '/music/dust-and-hardcovers.mp3'
    },
    {
        id: 'track-93',
        title: 'Harbor Before Words',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'harbor-before-words.mp3',
        category: 'jazzhop',
        url: '/music/harbor-before-words.mp3'
    },
    {
        id: 'track-94',
        title: 'Last Call in C Minor',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'last-call-in-c-minor.mp3',
        category: 'jazzhop',
        url: '/music/last-call-in-c-minor.mp3'
    },
    {
        id: 'track-95',
        title: 'Linen and Limoncello',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'linen-and-limoncello.mp3',
        category: 'jazzhop',
        url: '/music/linen-and-limoncello.mp3'
    },
    {
        id: 'track-96',
        title: 'Midnight Amber Room',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-amber-room.mp3',
        category: 'jazzhop',
        url: '/music/midnight-amber-room.mp3'
    },
    {
        id: 'track-97',
        title: 'Rain on the Boulevard',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'rain-on-the-boulevard.mp3',
        category: 'jazzhop',
        url: '/music/rain-on-the-boulevard.mp3'
    },
    {
        id: 'track-98',
        title: 'Saxophone in the Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'saxophone-in-the-rain.mp3',
        category: 'jazzhop',
        url: '/music/saxophone-in-the-rain.mp3'
    },
    {
        id: 'track-99',
        title: 'Stacks of Quiet Books',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'stacks-of-quiet-books.mp3',
        category: 'jazzhop',
        url: '/music/stacks-of-quiet-books.mp3'
    },
    {
        id: 'track-100',
        title: 'Velvet Cigarette Haze',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'velvet-cigarette-haze.mp3',
        category: 'jazzhop',
        url: '/music/velvet-cigarette-haze.mp3'
    },
    {
        id: 'track-101',
        title: '3 AM Echoes',
        artist: 'Open Lo-Fi (CC0)',
        filename: '3-am-echoes.mp3',
        category: 'late-night',
        url: '/music/3-am-echoes.mp3'
    },
    {
        id: 'track-102',
        title: 'Antenna After Midnight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'antenna-after-midnight.mp3',
        category: 'late-night',
        url: '/music/antenna-after-midnight.mp3'
    },
    {
        id: 'track-103',
        title: 'Blinds and Headlights',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'blinds-and-headlights.mp3',
        category: 'late-night',
        url: '/music/blinds-and-headlights.mp3'
    },
    {
        id: 'track-104',
        title: 'Electric Puddles',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'electric-puddles.mp3',
        category: 'late-night',
        url: '/music/electric-puddles.mp3'
    },
    {
        id: 'track-105',
        title: 'Elevator To the Moon',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'elevator-to-the-moon.mp3',
        category: 'late-night',
        url: '/music/elevator-to-the-moon.mp3'
    },
    {
        id: 'track-106',
        title: 'Empty Street Static',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'empty-street-static.mp3',
        category: 'late-night',
        url: '/music/empty-street-static.mp3'
    },
    {
        id: 'track-107',
        title: 'Half Empty Coupe',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'half-empty-coupe.mp3',
        category: 'late-night',
        url: '/music/half-empty-coupe.mp3'
    },
    {
        id: 'track-108',
        title: 'Headlights on the Divider',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'headlights-on-the-divider.mp3',
        category: 'late-night',
        url: '/music/headlights-on-the-divider.mp3'
    },
    {
        id: 'track-109',
        title: 'High Rise Haze',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'high-rise-haze.mp3',
        category: 'late-night',
        url: '/music/high-rise-haze.mp3'
    },
    {
        id: 'track-110',
        title: 'Last Call at Table Nine',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'last-call-at-table-nine.mp3',
        category: 'late-night',
        url: '/music/last-call-at-table-nine.mp3'
    },
    {
        id: 'track-111',
        title: 'Last Train Home',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'last-train-home.mp3',
        category: 'late-night',
        url: '/music/last-train-home.mp3'
    },
    {
        id: 'track-112',
        title: 'Midnight on My Mind',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-on-my-mind.mp3',
        category: 'late-night',
        url: '/music/midnight-on-my-mind.mp3'
    },
    {
        id: 'track-113',
        title: 'Midnight Window Glow',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-window-glow.mp3',
        category: 'late-night',
        url: '/music/midnight-window-glow.mp3'
    },
    {
        id: 'track-114',
        title: 'Platform After Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'platform-after-rain.mp3',
        category: 'late-night',
        url: '/music/platform-after-rain.mp3'
    },
    {
        id: 'track-115',
        title: 'Rain Off the Neon Signs',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'rain-off-the-neon-signs.mp3',
        category: 'late-night',
        url: '/music/rain-off-the-neon-signs.mp3'
    },
    {
        id: 'track-116',
        title: 'Rooftop Static Dreams',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'rooftop-static-dreams.mp3',
        category: 'late-night',
        url: '/music/rooftop-static-dreams.mp3'
    },
    {
        id: 'track-117',
        title: 'Streetlights in the Rearview',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'streetlights-in-the-rearview.mp3',
        category: 'late-night',
        url: '/music/streetlights-in-the-rearview.mp3'
    },
    {
        id: 'track-118',
        title: 'Warm Mile Markers',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'warm-mile-markers.mp3',
        category: 'late-night',
        url: '/music/warm-mile-markers.mp3'
    },
    {
        id: 'track-119',
        title: 'A Taste of Spring',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'a-taste-of-spring.mp3',
        category: 'seasonal-weather',
        url: '/music/a-taste-of-spring.mp3'
    },
    {
        id: 'track-120',
        title: 'After School Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'after-school-rain.mp3',
        category: 'seasonal-weather',
        url: '/music/after-school-rain.mp3'
    },
    {
        id: 'track-121',
        title: 'Amber Sidewalks',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'amber-sidewalks.mp3',
        category: 'seasonal-weather',
        url: '/music/amber-sidewalks.mp3'
    },
    {
        id: 'track-122',
        title: 'Amber Windowpane',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'amber-windowpane.mp3',
        category: 'seasonal-weather',
        url: '/music/amber-windowpane.mp3'
    },
    {
        id: 'track-123',
        title: 'Autumn on the Window Glass',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'autumn-on-the-window-glass.mp3',
        category: 'seasonal-weather',
        url: '/music/autumn-on-the-window-glass.mp3'
    },
    {
        id: 'track-124',
        title: 'Bloom Between Showers',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'bloom-between-showers.mp3',
        category: 'seasonal-weather',
        url: '/music/bloom-between-showers.mp3'
    },
    {
        id: 'track-125',
        title: 'Blossoms on the Pavement',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'blossoms-on-the-pavement.mp3',
        category: 'seasonal-weather',
        url: '/music/blossoms-on-the-pavement.mp3'
    },
    {
        id: 'track-126',
        title: 'Embers After Midnight',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'embers-after-midnight.mp3',
        category: 'seasonal-weather',
        url: '/music/embers-after-midnight.mp3'
    },
    {
        id: 'track-127',
        title: 'Fallen Leaves Loop',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'fallen-leaves-loop.mp3',
        category: 'seasonal-weather',
        url: '/music/fallen-leaves-loop.mp3'
    },
    {
        id: 'track-128',
        title: 'Fieldnotes at Dawn',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'fieldnotes-at-dawn.mp3',
        category: 'seasonal-weather',
        url: '/music/fieldnotes-at-dawn.mp3'
    },
    {
        id: 'track-129',
        title: 'Fireplace Loop',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'fireplace-loop.mp3',
        category: 'seasonal-weather',
        url: '/music/fireplace-loop.mp3'
    },
    {
        id: 'track-130',
        title: 'Hammock in the Shade',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'hammock-in-the-shade.mp3',
        category: 'seasonal-weather',
        url: '/music/hammock-in-the-shade.mp3'
    },
    {
        id: 'track-131',
        title: 'Lemonade Film Grain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'lemonade-film-grain.mp3',
        category: 'seasonal-weather',
        url: '/music/lemonade-film-grain.mp3'
    },
    {
        id: 'track-132',
        title: 'Mist Over Green Fields',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'mist-over-green-fields.mp3',
        category: 'seasonal-weather',
        url: '/music/mist-over-green-fields.mp3'
    },
    {
        id: 'track-133',
        title: 'Moon Over Red Dunes',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'moon-over-red-dunes.mp3',
        category: 'seasonal-weather',
        url: '/music/moon-over-red-dunes.mp3'
    },
    {
        id: 'track-134',
        title: 'Palm Breeze Nap',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'palm-breeze-nap.mp3',
        category: 'seasonal-weather',
        url: '/music/palm-breeze-nap.mp3'
    },
    {
        id: 'track-135',
        title: 'Petals After Rain',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'petals-after-rain.mp3',
        category: 'seasonal-weather',
        url: '/music/petals-after-rain.mp3'
    },
    {
        id: 'track-136',
        title: 'Petals in the Breeze',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'petals-in-the-breeze.mp3',
        category: 'seasonal-weather',
        url: '/music/petals-in-the-breeze.mp3'
    },
    {
        id: 'track-137',
        title: 'Picnic Polaroids',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'picnic-polaroids.mp3',
        category: 'seasonal-weather',
        url: '/music/picnic-polaroids.mp3'
    },
    {
        id: 'track-138',
        title: 'Sidewalk Puddles',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'sidewalk-puddles.mp3',
        category: 'seasonal-weather',
        url: '/music/sidewalk-puddles.mp3'
    },
    {
        id: 'track-139',
        title: 'Snow on the Needle',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'snow-on-the-needle.mp3',
        category: 'seasonal-weather',
        url: '/music/snow-on-the-needle.mp3'
    },
    {
        id: 'track-140',
        title: 'Spring Garden Loops',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'spring-garden-loops.mp3',
        category: 'seasonal-weather',
        url: '/music/spring-garden-loops.mp3'
    },
    {
        id: 'track-141',
        title: 'Starlight in the Sand',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'starlight-in-the-sand.mp3',
        category: 'seasonal-weather',
        url: '/music/starlight-in-the-sand.mp3'
    },
    {
        id: 'track-142',
        title: 'Storm Over Side Streets',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'storm-over-side-streets.mp3',
        category: 'seasonal-weather',
        url: '/music/storm-over-side-streets.mp3'
    },
    {
        id: 'track-143',
        title: 'Thunder in the Dust',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'thunder-in-the-dust.mp3',
        category: 'seasonal-weather',
        url: '/music/thunder-in-the-dust.mp3'
    },
    {
        id: 'track-144',
        title: 'Tide Stained Polaroids',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'tide-stained-polaroids.mp3',
        category: 'seasonal-weather',
        url: '/music/tide-stained-polaroids.mp3'
    },
    {
        id: 'track-145',
        title: 'Winter Turntable',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'winter-turntable.mp3',
        category: 'seasonal-weather',
        url: '/music/winter-turntable.mp3'
    },
    {
        id: 'track-146',
        title: '3AM Sink Light',
        artist: 'Open Lo-Fi (CC0)',
        filename: '3am-sink-light.mp3',
        category: 'soul-rnb',
        url: '/music/3am-sink-light.mp3'
    },
    {
        id: 'track-147',
        title: 'Barefoot in the Kitchen',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'barefoot-in-the-kitchen.mp3',
        category: 'soul-rnb',
        url: '/music/barefoot-in-the-kitchen.mp3'
    },
    {
        id: 'track-148',
        title: 'Candle Wax Heart',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'candle-wax-heart.mp3',
        category: 'soul-rnb',
        url: '/music/candle-wax-heart.mp3'
    },
    {
        id: 'track-149',
        title: 'Envelope on the Bed',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'envelope-on-the-bed.mp3',
        category: 'soul-rnb',
        url: '/music/envelope-on-the-bed.mp3'
    },
    {
        id: 'track-150',
        title: 'Golden Afternoon Groove',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'golden-afternoon-groove.mp3',
        category: 'soul-rnb',
        url: '/music/golden-afternoon-groove.mp3'
    },
    {
        id: 'track-151',
        title: 'Honey on the Speakers',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'honey-on-the-speakers.mp3',
        category: 'soul-rnb',
        url: '/music/honey-on-the-speakers.mp3'
    },
    {
        id: 'track-152',
        title: 'Kitchen After the Party',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'kitchen-after-the-party.mp3',
        category: 'soul-rnb',
        url: '/music/kitchen-after-the-party.mp3'
    },
    {
        id: 'track-153',
        title: 'Lazy Love Letter Afternoon',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'lazy-love-letter-afternoon.mp3',
        category: 'soul-rnb',
        url: '/music/lazy-love-letter-afternoon.mp3'
    },
    {
        id: 'track-154',
        title: 'Midnight Notes on the Floor',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-notes-on-the-floor.mp3',
        category: 'soul-rnb',
        url: '/music/midnight-notes-on-the-floor.mp3'
    },
    {
        id: 'track-155',
        title: 'Midnight Table Talk',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'midnight-table-talk.mp3',
        category: 'soul-rnb',
        url: '/music/midnight-table-talk.mp3'
    },
    {
        id: 'track-156',
        title: 'Old Photos New Heart',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'old-photos-new-heart.mp3',
        category: 'soul-rnb',
        url: '/music/old-photos-new-heart.mp3'
    },
    {
        id: 'track-157',
        title: 'Polaroids in A Shoebox',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'polaroids-in-a-shoebox.mp3',
        category: 'soul-rnb',
        url: '/music/polaroids-in-a-shoebox.mp3'
    },
    {
        id: 'track-158',
        title: 'Porcelain Heartbeat',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'porcelain-heartbeat.mp3',
        category: 'soul-rnb',
        url: '/music/porcelain-heartbeat.mp3'
    },
    {
        id: 'track-159',
        title: 'Rain on Your Hoodie',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'rain-on-your-hoodie.mp3',
        category: 'soul-rnb',
        url: '/music/rain-on-your-hoodie.mp3'
    },
    {
        id: 'track-160',
        title: 'Record Player Embrace',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'record-player-embrace.mp3',
        category: 'soul-rnb',
        url: '/music/record-player-embrace.mp3'
    },
    {
        id: 'track-161',
        title: 'Rooftop Slow Jam',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'rooftop-slow-jam.mp3',
        category: 'soul-rnb',
        url: '/music/rooftop-slow-jam.mp3'
    },
    {
        id: 'track-162',
        title: 'Scattered Sheet Music',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'scattered-sheet-music.mp3',
        category: 'soul-rnb',
        url: '/music/scattered-sheet-music.mp3'
    },
    {
        id: 'track-163',
        title: 'Skyline and Satin',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'skyline-and-satin.mp3',
        category: 'soul-rnb',
        url: '/music/skyline-and-satin.mp3'
    },
    {
        id: 'track-164',
        title: 'Slow Dance in the Living Room',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'slow-dance-in-the-living-room.mp3',
        category: 'soul-rnb',
        url: '/music/slow-dance-in-the-living-room.mp3'
    },
    {
        id: 'track-165',
        title: 'Slow Dancing By the Stove',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'slow-dancing-by-the-stove.mp3',
        category: 'soul-rnb',
        url: '/music/slow-dancing-by-the-stove.mp3'
    },
    {
        id: 'track-166',
        title: 'Velvet Candle Smoke',
        artist: 'Open Lo-Fi (CC0)',
        filename: 'velvet-candle-smoke.mp3',
        category: 'soul-rnb',
        url: '/music/velvet-candle-smoke.mp3'
    },
];
